export default "__VITE_ASSET__DcS8ko0I__"